import React from "react";
import { ShieldCheck, Lightbulb, Handshake } from "lucide-react";
const features = [{
  id: "expertise",
  icon: ShieldCheck,
  title: "Specialist Insurance Repairs",
  descriptionPart1: "We specialize in navigating complex insurance claims for hail damage and structural impacts. Our team works directly with major providers to ensure your caravan is restored to factory standards without the stress.",
  descriptionPart2: "From initial assessment to final inspection, we document every step of the repair process, providing the transparency and technical precision required for high-stakes insurance restoration work in Sydney."
}, {
  id: "innovation",
  icon: Lightbulb,
  title: "Technical System Installations",
  descriptionPart1: "Beyond repairs, we enhance your travel experience with professional installations of solar systems, air conditioning, and electrical upgrades. Our technicians are experts in modern caravan technology.",
  descriptionPart2: "We utilize industrial-grade components and follow strict safety protocols, ensuring your new systems are integrated seamlessly into your caravan's existing framework for maximum reliability on the road."
}, {
  id: "partnership",
  icon: Handshake,
  title: "Reliable Quality Craftsmanship",
  descriptionPart1: "Our South Windsor facility is equipped with the latest tools to handle everything from intricate plumbing to heavy structural welding. We treat every caravan as if it were our own project.",
  descriptionPart2: "With a focus on long-term durability and customer satisfaction, our repairs aren't just about looks—they're about ensuring your caravan remains safe and roadworthy for your next great Australian adventure."
}];
export default function WhyChooseUs() {
  return <section data-section-id="89796" id="why-choose-caravan-smash-repairs" className="bg-background relative overflow-hidden py-24 md:py-32 text-foreground">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-primary tracking-tighter mb-6 uppercase">
            Why Choose Caravan Smash Repairs
          </h2>
          <p className="text-lg text-muted-foreground leading-[1.6] max-w-2xl font-medium">
            Expert restoration and maintenance for your home on wheels, delivered with Sydney's most trusted craftsmanship and industrial precision.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="absolute left-[31px] top-12 bottom-12 w-px bg-gradient-to-b from-transparent via-secondary/30 to-transparent hidden md:block" aria-hidden="true" />

          <div className="flex flex-col gap-16">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <div key={feature.id} data-index={i} className="group relative flex flex-col md:flex-row gap-8 md:gap-12 items-start">
                  {}
                  <div className="relative shrink-0 z-10">
                    {}
                    <div className="absolute inset-0 bg-secondary/10 rounded-2xl rotate-6 transition-transform duration-500 group-hover:rotate-12" />
                    {}
                    <div className="relative w-16 h-16 bg-card border border-border/50 shadow-md rounded-2xl flex items-center justify-center transition-transform duration-500 group-hover:-translate-y-1 group-hover:-translate-x-1">
                      <Icon className="w-8 h-8 text-secondary" strokeWidth={2} />
                    </div>
                  </div>

                  {}
                  <div className="flex-1 pt-2">
                    <h3 className="text-2xl font-bold text-primary mb-6 tracking-tight">
                      {feature.title}
                    </h3>
                    <div className="grid md:grid-cols-2 gap-6 md:gap-10 text-muted-foreground leading-[1.6] font-normal">
                      <p>{feature.descriptionPart1}</p>
                      <p>{feature.descriptionPart2}</p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}